import { type SelectionFeature, type SelectionFeatureActivationContext } from '../types';

/**
 * Drops selection features whose `isEnabled(ctx)` returns false.
 *
 * `ctx` is built once per selections-machine setup (see
 * `initialize-recyclable-selections-machine`). The machine is rebuilt when
 * permissions or view id / layout type change so `isEnabled` is re-evaluated
 * with fresh `permissions` and `layoutType`.
 *
 * Features without `isEnabled` are always kept. Omitted `isEnabled` means the
 * mode list alone decides inclusion.
 */
export function filterSelectionFeatures(
  features: readonly SelectionFeature[],
  ctx: SelectionFeatureActivationContext
): SelectionFeature[] {
  return features.filter((f) => f.isEnabled?.(ctx) !== false);
}
